import { render, staticRenderFns } from "./TaskDetail.vue?vue&type=template&id=309e44a6&scoped=true"
import script from "./TaskDetail.vue?vue&type=script&lang=ts"
export * from "./TaskDetail.vue?vue&type=script&lang=ts"
import style0 from "./TaskDetail.vue?vue&type=style&index=0&id=309e44a6&prod&lang=scss&scoped=true"
import style1 from "./TaskDetail.vue?vue&type=style&index=1&id=309e44a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "309e44a6",
  null
  
)

export default component.exports